import type { AIPromptContext, AIPromptMessage, AIPromptResult, AIPromptSpec, AIPromptTool, Command } from './plugin-types.js'

export type ExecuteAIPrompt = (params: {
  messages: AIPromptMessage[]
  tools?: Record<string, AIPromptTool>
}) => Promise<AIPromptResult>

/** Convert an AIPromptSpec into a Command so it appears in the existing command menu. */
export const aiPromptToCommand = <TParams>(
  spec: AIPromptSpec<TParams>,
  context: Omit<AIPromptContext<TParams>, 'params'>,
  execute: ExecuteAIPrompt
): Command<TParams> => ({
  id: spec.id,
  name: spec.name,
  Icon: spec.Icon,
  blockOnRun: true,
  cmdParamsSchema: spec.paramsSchema,
  cmd: async params => {
    const fullContext = { ...context, params } as AIPromptContext<TParams>
    spec.onStart?.(fullContext)
    const messages = await spec.getMessages(fullContext)
    const result = await execute({ messages, tools: spec.tools })
    await spec.onResult(fullContext, result)
  },
})
